import React from 'react';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
    padding: 0
  },
  overview: {
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3)
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  header: {
    color: theme.palette.text.secondary,
    padding: theme.spacing(1),
    position: 'relative'
  }
}));

const OverviewContainer = ({ children }) => {
  const CLASSES = useStyles();
  return (
    <Container maxWidth="xl" className={CLASSES.overview}>
      {children}
    </Container>
  );
};

export default OverviewContainer;



// WEBPACK FOOTER //
// ./src/components/dispatches/OverviewContainer.js